import { InternalPageviewAutomaticTrackingChecker } from "./InternalPageviewAutomaticTrackingChecker";

export class DefaultInternalPageviewAutomaticTrackingChecker
	implements InternalPageviewAutomaticTrackingChecker
{
	shouldTrackPage(pageName: string | undefined): boolean {
		return (
			pageName === "Receipt" ||
			pageName === "Product Selection" ||
			pageName?.indexOf("Payment") === 0
		);
	}
}
